import { ClaimMappingFormValue, EMPTY_CLAIM_MAPPING_VALUE } from "components/FormFields/ClaimMapping";

export type SettingsSingleSignOnOIDCFormFields = {
  clientId: string;
  clientCredentials: string;
  identityProviderHost: string;
  claimMapping: ClaimMappingFormValue[];
};

export const formDefaultValues: SettingsSingleSignOnOIDCFormFields = {
  clientId: "",
  clientCredentials: "",
  identityProviderHost: "",
  claimMapping: [EMPTY_CLAIM_MAPPING_VALUE],
};
